"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GoogleWalletLightXs = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GoogleWalletLightXs = function GoogleWalletLightXs(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 44,
    height: 20,
    viewBox: "0 0 44 20",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#GoogleWalletLightXS_svg__GoogleWalletLightXS_svg__clip0_18246_92359)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.635 4.717v4.29h2.664c.634 0 1.16-.212 1.575-.635a2.06 2.06 0 00.639-1.51c0-.572-.214-1.07-.64-1.494-.415-.434-.94-.652-1.574-.652h-2.664v.001zm0 5.8v4.976h-1.591V3.207h4.22c1.073 0 1.983.355 2.733 1.064.762.709 1.142 1.573 1.142 2.59 0 1.042-.38 1.912-1.142 2.609-.738.698-1.65 1.046-2.733 1.046h-2.63v.001zm8.112 2.403c0 .411.176.755.528 1.029a1.95 1.95 0 001.237.412c.669 0 1.265-.246 1.79-.738.525-.492.787-1.07.787-1.732-.497-.39-1.188-.584-2.076-.584-.647 0-1.185.155-1.617.464-.432.309-.649.69-.649 1.148zm2.06-6.11c1.176 0 2.104.312 2.785.936.68.624 1.02 1.479 1.02 2.565v5.182H33.09v-1.166h-.07c-.657.96-1.534 1.441-2.629 1.441-.934 0-1.716-.275-2.344-.824-.628-.549-.942-1.235-.942-2.059 0-.87.33-1.561.994-2.076.663-.514 1.548-.772 2.655-.772.945 0 1.724.171 2.335.514v-.36c0-.55-.22-1.015-.658-1.399a2.264 2.264 0 00-1.539-.574c-.888 0-1.591.371-2.11 1.116l-1.402-.876c.773-1.098 1.915-1.647 3.426-1.647zm12.54.275L38.037 19.2h-1.644l1.972-4.239-3.494-7.876h1.73l2.526 6.04h.034l2.456-6.04h1.73z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.204 9.444a8.35 8.35 0 00-.122-1.435H7.37v2.719h3.844a3.268 3.268 0 01-1.421 2.145v1.766h2.294c1.344-1.23 2.117-3.046 2.117-5.195z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37 16.344c1.92 0 3.538-.626 4.717-1.705l-2.294-1.766c-.639.427-1.461.676-2.423.676-1.856 0-3.432-1.241-3.995-2.914H1.01v1.819a7.123 7.123 0 006.36 3.89z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 10.635a4.212 4.212 0 010-2.703V6.113H1.01a6.977 6.977 0 00-.758 3.17c0 1.14.274 2.218.758 3.17l2.364-1.818z",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37 5.018c1.049 0 1.989.358 2.73 1.06l2.032-2.015c-1.234-1.14-2.842-1.84-4.762-1.84a7.123 7.123 0 00-6.359 3.89l2.364 1.82C3.938 6.26 5.514 5.017 7.37 5.017z",
    fill: "#E94235"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "GoogleWalletLightXS_svg__GoogleWalletLightXS_svg__clip0_18246_92359"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h44v20H0z"
  }))));
};

exports.GoogleWalletLightXs = GoogleWalletLightXs;
var _default = GoogleWalletLightXs;
exports.default = _default;